import React from "react";
import { Button, Modal } from "antd";
import { useTranslation } from "react-i18next";
import "./otpmodal.scss";
import { useVerifyOtpPackage } from "dataLayer/user";
import OtpInput from "react-otp-input";
import BitelModal from ".";
import PackSuccess from "@pages/Events/NewYearAndChristmas_2024/Components/animtion/PackSuccess";
import PopupCompleteMission from "@pages/Events/MiniGame/components/PopupFooter/PopupCompleteMission";

const OtpModal = ({
  visible,
  handleCancelOtp,
  dataGetOtp,
  selectedPackPrice,
  selectedPack,
  isShow,
}) => {
  const { t } = useTranslation();
  const { mutate: mutateVerifyOTP, data: dataVerifyOtp } =
    useVerifyOtpPackage();
  const [otp, setOtp] = React.useState("");

  const [pendingReward, setPendingReward] = React.useState(null);
  const [showMinigamePopup, setShowMinigamePopup] = React.useState(false);
  const [minigameRewardData, setMinigameRewardData] = React.useState(null);

  React.useEffect(() => {
    setOtp("");
  }, [visible]);

  const handleChangeOtp = (otp) => {
    setOtp(otp);
  };

  const handleVerifyOtp = () => {
    handleCancelOtp();
    if (dataGetOtp?.data?.content === "Success") {
      mutateVerifyOTP(
        { selectedPackPrice, selectedPack, otp }
        // {
        //   onSuccess: () => {
        //     processAfterVerify();
        //   },
        // }
      );
    }
  };

  React.useEffect(() => {
    if (+dataVerifyOtp?.data?.errorCode === 0) {
      if (
        dataVerifyOtp?.data?.reelAddNormal > 0 ||
        dataVerifyOtp?.data?.reelAddSuper > 0
      ) {
        setPendingReward(dataVerifyOtp.data);
      }
    }
  }, [dataVerifyOtp]);  

  const handleBitelModalClose = () => {
    
    if (pendingReward) {
      setMinigameRewardData(pendingReward);
      setTimeout(() => {
        setShowMinigamePopup(true);
      }, 200);

      setPendingReward(null);
    }
  };  

  // const processAfterVerify = () => {
  //   if (dataVerifyOtp?.data?.content === "Success") {
  //     window.location.reload();
  //   }
  // };

  // const handleResendOTP = () => {
  //   mutateResend({ isdn });
  // };

  return (
    <>
      <PackSuccess
        isSuccessSubPack={+dataVerifyOtp?.data?.errorCode === 0}
        selectedPack={selectedPack}
        isShow={isShow}
      />
      <Modal
        visible={visible}
        onCancel={handleCancelOtp}
        footer={[
          // <Button
          //   type="primary"
          //   className="otp-button"
          //   onClick={handleResendOTP}
          //   loading={isLoadingResend}>
          //   {t("verifyOTP.resend")}
          // </Button>,
          <Button
            key={1}
            type="primary"
            htmlType="submit"
            className="otp-button"
            onClick={handleVerifyOtp}
            disabled={otp.length !== 6}
          >
            {t("verifyOTP.send_code")}
          </Button>,
        ]}
      >
        <h1 className="ant-modal-body-title-otp">
          {t("verifyOTP.buy_package")}
        </h1>
        <div className="ant-modal-body-wrapper-otp">
          <OtpInput
            value={otp}
            onChange={handleChangeOtp}
            numInputs={6}
            separator={<span>-</span>}
            inputStyle="input-otp"
            isInputNum={true}
          />
        </div>
      </Modal>
      {/* <BitelModal
        defaultMsg={t("account.subscription")}
        data={dataVerifyOtp?.data?.content}
        error={dataVerifyOtp?.data?.content}
        titleSuccess={t("success")}
        btnSuccess={t("modal.thank")}
      /> */}
      <BitelModal
        data={dataVerifyOtp?.data}
        error={dataVerifyOtp?.errorMessage}
        defaultMsg={t("account.subscription")}
        titleSuccess={t("success")}
        btnSuccess={t("modal.thank")}
        onClose={handleBitelModalClose}
      />

      <PopupCompleteMission
        visible={showMinigamePopup}
        setVisible={setShowMinigamePopup}
        data={minigameRewardData}
      />      
    </>
  );
};

export default OtpModal;
